import _asyncToGenerator from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _createSuper from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/createSuper.js";
import "regenerator-runtime/runtime.js";
// Copyright 2017-2022 @polkadot/api authors & contributors
// SPDX-License-Identifier: Apache-2.0
import { assert, isString, objectSpread, u8aToHex, u8aToU8a } from '@polkadot/util';
import { Getters } from "./Getters.js";
export var ApiBase = /*#__PURE__*/function (_Getters) {
  _inherits(ApiBase, _Getters);

  var _super = _createSuper(ApiBase);

  /**
   * @description Create an instance of the class
   *
   * @param options Options object to create API instance or a Provider instance
   *
   * @example
   * <BR>
   *
   * ```javascript
   * import Api from '@polkadot/api/promise';
   *
   * const api = new Api().isReady();
   *
   * api.rpc.subscribeNewHeads((header) => {
   *   console.log(`new block #${header.number.toNumber()}`);
   * });
   * ```
   */
  function ApiBase() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var type = arguments.length > 1 ? arguments[1] : undefined;
    var decorateMethod = arguments.length > 2 ? arguments[2] : undefined;

    _classCallCheck(this, ApiBase);

    return _super.call(this, options, type, decorateMethod);
  }
  /**
   * @description Connect from the underlying provider, halting all network traffic
   */


  _createClass(ApiBase, [{
    key: "connect",
    value: function connect() {
      return this._rpcCore.connect();
    }
    /**
     * @description Disconnect from the underlying provider, halting all network traffic
     */

  }, {
    key: "disconnect",
    value: function disconnect() {
      this._unsubscribe();

      return this._rpcCore.disconnect();
    }
    /**
     * @description Set an external signer which will be used to sign extrinsic when account passed in is not KeyringPair
     */

  }, {
    key: "setSigner",
    value: function setSigner(signer) {
      this._rx.signer = signer;
    }
    /**
     * @description Signs a raw signer payload, string or Uint8Array
     */

  }, {
    key: "sign",
    value: function () {
      var _sign = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(address, data) {
        var _ref,
            signer,
            _signer,
            _args = arguments;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _ref = _args.length > 2 && _args[2] !== undefined ? _args[2] : {}, signer = _ref.signer;

                if (!isString(address)) {
                  _context.next = 7;
                  break;
                }

                _signer = signer || this._rx.signer;
                assert(_signer === null || _signer === void 0 ? void 0 : _signer.signRaw, 'No signer exists with a signRaw interface. You possibly need to pass through an explicit keypair for the origin so it can be used for signing.');
                _context.next = 6;
                return _signer.signRaw(objectSpread({
                  type: 'bytes'
                }, data, {
                  address: address
                }));

              case 6:
                return _context.abrupt("return", _context.sent.signature);

              case 7:
                return _context.abrupt("return", u8aToHex(address.sign(u8aToU8a(data.data))));

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function sign(_x, _x2) {
        return _sign.apply(this, arguments);
      }

      return sign;
    }()
  }]);

  return ApiBase;
}(Getters);